import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IGetConversationByIdOutput, IThreadOutput } from '../../../../graphql/types/queries/conversation'
import { Tag } from '../../../../components/Tag'
import styled from 'styled-components';
import { Conversations } from './Conversation';
import { IUser } from '../../../../graphql/types/queries/user';
import EmbedInputBar from '../EmbedInputBar';
import { IProviderChangeStatusConversationInput, IProviderChangeStatusConversationOutput, IProviderReassignConversationInput, IProviderReassignConversationOutput, IUnsnoozeConversationInput, IUnsnoozeConversationOutput } from '../../../../graphql/types/mutations/conversation';
import { ApolloCache, DefaultContext, MutationFunctionOptions, useMutation } from '@apollo/client';
import Modal from 'styled-react-modal';
import { SpecialModalBackground } from '../../../../components/Commons';
import { ConvoTagging } from '../ConvoTagging';
import { useEffect, useRef } from 'react';
import { UNSNOOZE_CONVERSATION } from '../../../../graphql/mutations';
import { GET_CONVERSATION_BY_ID } from '../../../../graphql/queries';
import moment from 'moment';


interface IMessengerEmbeddedInnerProps {
  loading?: boolean
  data: IGetConversationByIdOutput | undefined
  conversationId: number | string
  isNoting: boolean
  isReplying: boolean
  isPatientConvo: boolean
  conversation: IThreadOutput[] | null
  session: IUser
  setIsTagging: (value: React.SetStateAction<boolean>) => void
  setIsNoting: (value: React.SetStateAction<boolean>) => void
  setIsReplying: (value: React.SetStateAction<boolean>) => void
  reassignConversation: (options?: MutationFunctionOptions<IProviderReassignConversationOutput, IProviderReassignConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<any>
  changeStatusConversation: (options?: MutationFunctionOptions<IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<any>
  openNoting: () => void
  openReplying: () => void
  mailboxId?: number,
  athenaId?: string | null,
  isTagging: boolean
  messagesEndRef: React.RefObject<any>
  onSendReplyHandler: (html: string, assignedTo: number, status: string, attachments: {
    fileName: string;
    mimeType: string;
    data: string;
    size: number;
  }[] | null) => Promise<void>
}

const convertToFriendly = (time?: string) => {
  if (!time) return ''
  const mom = moment(time)
  const now = moment()

  if (mom.isSame(now, 'day')) {
    return `Today, ${mom.format('hh:mmA')}`
  }
  if (mom.isSame(moment().add(1, 'day'), 'day')) {
    return `Tomorrow, ${mom.format('hh:mmA')}`
  }
  if (mom.isSame(now, 'week')) {
    return `${mom.format('dddd')}, ${mom.format('hh:mmA')}`
  }
  return `${mom.format('MM/DD/YYYY, hh:mmA')}`
}

export const MessengerEmbeddedInner: React.FC<IMessengerEmbeddedInnerProps> = ({
  loading,
  data,
  conversationId,
  isNoting,
  isReplying,
  isPatientConvo,
  conversation,
  session,
  setIsTagging,
  setIsNoting,
  setIsReplying,
  reassignConversation,
  changeStatusConversation,
  openNoting,
  openReplying,
  onSendReplyHandler,
  isTagging,
  messagesEndRef,mailboxId, athenaId,
}) => {

  const toastIdUnSnooze = useRef<any>(null);
  const [unsnooze, { loading: loadingUnSnooze, error: errorUnSnooze, data: dataUnSnooze }] = useMutation<IUnsnoozeConversationOutput, IUnsnoozeConversationInput>(UNSNOOZE_CONVERSATION, {
    refetchQueries: [{
      query: GET_CONVERSATION_BY_ID,
      variables: { conversationId: (conversationId||'').toString() }
    }]
  })
  useEffect(() => {
    console.log('UE convoID', conversationId)
    if (conversationId) {
      setTimeout(() => {
        console.log('UE selectedMailbox setTimeout')
        if (!!messagesEndRef.current) {
          console.log('UE selectedMailbox setTimeout current')
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
        } else {
        }
      }, 300)
    }
  }, [conversationId])
  if (!conversationId) {
    return null
  }
  
  return (
    <>
      {!loading && !!data && !!data?.providerGetConversationById && !!data?.providerGetConversationById ? (
        <>

          <Flex marginY={2} marginX={3} mr={4} alignItems='center' flexDirection={['column-reverse', 'row', 'row']}>
            {/* <Text fontWeight={500} fontSize='20px' textAlign={'left'} flex={1}>{data?.providerGetConversationById.subject}</Text> */}
          </Flex>
          {data?.providerGetConversationById.tags && (
            <Flex marginX={3} mr={4} flexWrap={'wrap'}>
              {data?.providerGetConversationById.tags.map(x => {
                return (
                  <Flex key={x.tag} mb={2}>
                    <Tag tag={x} />
                  </Flex>
                )
              })}
            </Flex>
          )}

          {data &&
            data.providerGetConversationById &&
            data.providerGetConversationById.convoTree &&
            data.providerGetConversationById.convoTree.tree &&
            data.providerGetConversationById.convoTree.tree.length > 0
            && data.providerGetConversationById.convoTree.parent !== conversationId.toString()
            && (
              <Flex style={{ borderBottom: '1px solid #e5e9ec', width: '100%', padding: '12px', paddingLeft: '30px', background: '#db8e00' }}>
                <Text mr={2} style={{ color: 'white' }}>This conversation is no longer editable. For further communications please use</Text>
                <Link style={{ color: 'white' }} to={`/messages/${data.providerGetConversationById.convoTree.parent}`}>this conversation</Link>
              </Flex>
            )}

          <Flex flex={1} flexDirection='column' minHeight={['200px', 0, 0]} style={{ overflow: 'hidden', paddingTop: '23px', paddingBottom: '23px', position: 'relative' }}>
          {!!data && !!data.providerGetConversationById && data.providerGetConversationById.msnooze && (
            <Flex style={{ padding: '6px 18px', background: '#f5f5f5', minHeight: '36px', alignItems: 'center', opacity: !loadingUnSnooze && !loading ? 1 : 0.3 }}>
              <Text flex={1} color={'rgb(95, 99, 104)'}>Snoozed until {convertToFriendly(data.providerGetConversationById.msnooze.reactivateOn)}</Text>
              <Text style={{ cursor: 'pointer' }} onClick={async () => {

                if (toastIdUnSnooze && toastIdUnSnooze.current) {
                  toast.dismiss(toastIdUnSnooze.current)
                }
                toastIdUnSnooze.current = toast(`Removing snooze`, { autoClose: false, isLoading: true, closeButton: false });
                await unsnooze({
                  variables: {
                    conversationId: conversationId.toString()
                  }
                })
                toast.update(toastIdUnSnooze.current, {
                  render: 'Snooze Removed',
                  type: toast.TYPE.SUCCESS,
                  isLoading: false,
                  autoClose: 5000,
                  closeButton: null // The closeButton defined on ToastContainer will be used
                });
              }}>Unsnooze</Text>
            </Flex>
          )}
            <ConvoWrapper flex={1} flexDirection={'column'} style={{ overflowY: 'scroll', overflowX: 'hidden', paddingBottom: !isNoting && !isReplying ? '60px' : '400px' }}>
              <Conversations isPatientConvo={isPatientConvo} conversation={conversation} session={session} />
              <div ref={messagesEndRef} id='inVite' style={{ width: '100%', height: '20px' }} >&nbsp;</div>
            </ConvoWrapper>
            <EmbedInputBar
            conversation={conversation}
            mailboxId={mailboxId}
            athenaId={athenaId}
              onTags={() => setIsTagging(true)}
              onDiscard={() => {
                setIsNoting(false)
                setIsReplying(false)
              }}
              isPatientConvo={isPatientConvo}
              conversationId={conversationId.toString()}
              reassignConversation={reassignConversation}
              changeStatusConversation={changeStatusConversation}
              onNote={openNoting}
              isNoting={isNoting}
              onReply={openReplying}
              isReplying={isReplying}
              sendReplyHandler={onSendReplyHandler as any} />
          </Flex>
        </>
      ) : null}

      {!!isTagging && !!data && data.providerGetConversationById && (
        <StyledModal
          isOpen={true}
          onBackgroundClick={() => {
            setIsTagging(false);
          }}
          onEscapeKeydown={() => {
            setIsTagging(false);
          }}
        >
          <SpecialModalBackground
            style={{ zIndex: 1000 }}
            onClick={() => {
              setIsTagging(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <ConvoTagging convo={data.providerGetConversationById} close={() => {
                  setIsTagging(false);
                }} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </StyledModal>
      )}
    </>);
}


const StyledModal = Modal.styled`
  z-index:1000;
`;
const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const ConvoWrapper = styled(Flex)`
  overflow-y: auto;
  width: 100%;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
      width: 7px;
      border: 1px solid transparent;
  }
`;